/*
 * Javier Quevedo-Fernandez
 * Copyright Ranj Games. 2013
 */

/*
 *  @constructor
 *  
 * @param {Bool} backgroundOverlay. Required
 * @param {Number} priority. Required
 * @param {BackgroundOverlayStyle} backgroundOverlayStyle. Optional. Defaults to null
 * @discussion rename backgroundOverlay to hasBackgroundOverlay
 * @returns {Initialized Object}
 */

export default class PopUpInfo {
    constructor(needsOverlay, priority, overlayStyle) {
        this.needsOverlay = needsOverlay;
        this.priority = priority;
        this.overlayStyle = overlayStyle;
        this.destroyWhenClosed = false;
    }
}